import Api from 'utils/api'

export const fetchCandidates = ({
  id,
  query,
}: {
  id: number | string
  query: string
}) => Api.get(['candidates', id], query)

/**
 * One earlier talent result in full.
 *
 * The candidate detail response lists the runs but not their payloads — each is several
 * hundred KB — so an older version's scores are fetched only when its tab is opened.
 */
export const fetchScoreRun = ({
  id,
  runId,
  query,
}: {
  id: number | string
  runId: string
  query?: Record<string, unknown>
}) => Api.get(['candidates', id, 'score-runs', runId], query)
